/** «USD 1.234,50»; el peso chileno sin decimales. */
export function monto(n: number | null | undefined, moneda: string | null | undefined): string {
  if (n === null || n === undefined) return "—";
  const decimales = moneda === "CLP" ? 0 : 2;
  const cifra = new Intl.NumberFormat("es-CL", {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  }).format(n);
  return moneda ? `${moneda} ${cifra}` : cifra;
}

/** «1 día», «3 días». */
export function plural(n: number, uno: string, varios: string): string {
  return `${n} ${Math.abs(n) === 1 ? uno : varios}`;
}

/**
 * Nombres propios que en SimplGo vienen en mayúsculas («SAN ANTONIO» → «San Antonio»),
 * con artículos y preposiciones en minúscula y las siglas societarias bien escritas.
 */
export function nombrePropio(s: string | null | undefined): string {
  return (
    String(s ?? "")
      .toLowerCase()
      .replace(/(^|[\s(/-])([a-záéíóúñ])/g, (_m, a: string, b: string) => a + b.toUpperCase())
      // Con búsqueda hacia atrás, para que «De La» seguidas queden ambas en minúscula.
      .replace(/(?<= )(E|Y|De|Del|La|Los|Las)(?= \S)/g, (m) => m.toLowerCase())
      .replace(/\bS\.a\b\.?/g, "S.A.")
      .replace(/\bS\.p\.a\b\.?/g, "S.p.A.")
      .replace(/\bSpa\b\.?$/, "SpA")
  );
}
